import { t, STATUS_ACTIONS } from "./constants";

// One-tap unit status action bar (ACK / ENROUTE / ON SCENE / … / CLEAR).
// Used on both the HOME and MAP views of the MDT.
export const MdtStatusBar = ({ unit, stLabel, stColor, onAction, testidPrefix = "mdt-status" }) => (
  <div data-testid="mdt-status-bar" className="shrink-0 rounded-lg border p-2 flex items-center gap-2 flex-wrap" style={{ background: t.panel, borderColor: t.border }}>
    <span className="font-mono text-[9px] uppercase px-1 shrink-0" style={{ color: t.dim }}>Unit Status · <span style={{ color: stColor }}>{stLabel}</span></span>
    {STATUS_ACTIONS.map(([s, label, color, Icon]) => {
      const active = unit?.status === s;
      return (
        <button key={s} data-testid={`${testidPrefix}-${s}`} onClick={() => onAction(s, label)}
          className="flex items-center gap-1.5 px-3 py-2 text-xs font-head font-bold rounded transition-colors"
          style={active ? { background: color, color: "#fff", boxShadow: `0 0 0 2px ${color}55` } : { background: t.surface, color: t.text, border: `1px solid ${t.border}` }}>
          <Icon size={14} style={active ? undefined : { color }} /> {label}
        </button>
      );
    })}
  </div>
);
